module.exports = __webpack_public_path__ + "cd62caf2905c7ca7ca8f9482df16beb4.svg";